import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Fragment } from 'react'
import configAws from '../config/aws'
import { Amplify, Auth } from 'aws-amplify'

Amplify.configure({
  Auth: {
    ...configAws.aws,
    authenticationFlowType: 'CUSTOM_AUTH',
  },
})

export let navigation = { navigate: null }

export const getBrowserName = () => {
  if (navigator.userAgent.indexOf('chrome') != -1) {
    return 'chrome'
  } else if (navigator.userAgent.indexOf('Firefox') != -1) {
    return 'firefox'
  } else if (navigator.userAgent.indexOf('Safari') != -1) {
    return 'safari'
  } else if (navigator.userAgent.indexOf('Edge') != -1) {
    return 'edge'
  }
}

export const askMicrophonePermission = () => {
  //Display custom message
  if (navigator.mediaDevices !== undefined) {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((result) => {
        console.log(result)
        //redirect to live page
      })
      .catch((error) => {
        //redirect to live page
        console.log(error)
      })
  }
}

export const capitalize = (word) => {
  const lower = word.toLowerCase()
  return word.charAt(0).toUpperCase() + lower.slice(1)
}

export const leToBr = (value) => {
  return value.split('\n').map((line, i, a) => (
    <Fragment key={i}>
      {line}
      {i < a.length - 1 ? <br /> : null}
    </Fragment>
  ))
}

export const useAnchorAutoScroll = () => {
  const location = useLocation()
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0)
    } else {
      const elmentToScroll = document.querySelector(location.hash)
      if (elmentToScroll) {
        elmentToScroll.scrollIntoView()
      }
    }
  }, [location.hash])
}

export const verifySession = async () => {
  return await Auth.currentSession()
}

export const autoLogin = async (challenge, email) => {
  const user = await Auth.signIn(email)
  await Auth.sendCustomChallengeAnswer(user, challenge)
  await Auth.currentSession()

  let refreshToken = user?.signInUserSession?.getRefreshToken().getToken()
  let idToken = user?.signInUserSession?.getIdToken().getJwtToken()

  if (idToken && refreshToken) {
    localStorage.setItem('access_token', idToken)
    localStorage.setItem('refresh_token', refreshToken)
  }
}
